import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core';
import { MDSTypography } from '@marqvision/mds-v2';

const useStyles = makeStyles(() => ({
  circle: {
    margin: '20px',
  },
  progress: {
    position: 'absolute',
    top: '32px',
    width: '82px',
    textAlign: 'center',
  },
}));

interface IProps {
  open: boolean;
  progress?: number;
}

const LoadingCircularProgress = ({ open, progress }: IProps) => {
  const classes = useStyles();

  return (
    <Dialog open={open}>
      <CircularProgress className={classes.circle} />
      {progress !== undefined && (
        <div className={classes.progress}>
          <MDSTypography
            variant="body"
            size="xs"
            color="color/content/primary/default/normal"
          >{`${progress}%`}</MDSTypography>
        </div>
      )}
    </Dialog>
  );
};

export default LoadingCircularProgress;
